export type ServiceRegistration = {
  name: string;
  layer:
    | "app"
    | "application"
    | "repository"
    | "service"
    | "observability"
    | "runtime";
  description: string;
};

export class ServiceRegistry {
  private readonly services = new Map<string, ServiceRegistration>();

  register(service: ServiceRegistration): void {
    this.services.set(service.name, service);
  }

  list(): ServiceRegistration[] {
    return [...this.services.values()].sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  }
}

export function createDefaultServiceRegistry(): ServiceRegistry {
  const registry = new ServiceRegistry();
  for (const service of [
    {
      name: "AuthService",
      layer: "application",
      description: "Google OAuth and owner identity orchestration.",
    },
    {
      name: "HealthService",
      layer: "service",
      description: "Runtime health checks.",
    },
    {
      name: "ObservabilityClient",
      layer: "observability",
      description: "Structured event emission.",
    },
    {
      name: "ProfileRepository",
      layer: "repository",
      description: "Profile data access.",
    },
    {
      name: "AuthorizationRepository",
      layer: "repository",
      description: "Owner role and access data access.",
    },
    {
      name: "AgentRuntime",
      layer: "runtime",
      description: "Agent lifecycle execution foundation.",
    },
    {
      name: "MemoryEngine",
      layer: "runtime",
      description: "Scoped memory storage foundation.",
    },
    {
      name: "ToolRegistry",
      layer: "runtime",
      description: "External tool capability registry.",
    },
    {
      name: "TaskEngine",
      layer: "runtime",
      description: "Task lifecycle foundation.",
    },
  ] as ServiceRegistration[]) {
    registry.register(service);
  }
  return registry;
}
